import { useMemo } from "react";

import t from "./translate";
import useAppContext from "components/AppContext";

export const useCompoundEligibility = () => {
  const { profile } = useAppContext();

  const stateIsCompoundEligible = useMemo(() => {
    if (profile?.mailingAddress?.state) {
      const excludedCompoundingStates =
        t("SEMAGLUTIDE_INELIGIBLE_STATES")?.split(",") || [];

      return !excludedCompoundingStates.includes(profile.mailingAddress.state);
    }
    return false;
  }, [profile]);

  return {
    compoundEligible: stateIsCompoundEligible
  };
};
